/* eslint-disable no-unused-vars */
import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import { Header, Footer, BodyWrapper, MobileFooter } from '../components'

const IframeBox = styled.div`
  max-width: 840px;
  margin: auto;
  iframe {
    width: 100%;
    height: 1350px;
    border: none;
  }
`

const TopDiv = styled.div`
  margin: 0 auto;
  max-width: 2560px;
`
const PerksTextWrapper = styled.div`
  padding-left: 30px;
  flex-basis: 60%;
  & > p:nth-child(1) {
    font-size: 16px;
    line-height: 1.63;
    letter-spacing: 1.6px;
    color: #333333;
  }
  & > p:nth-child(2) {
    font-size: 38px;

    line-height: 1.21;
    color: #333333;
  }
  & > ul {
    font-size: 16px;
    line-height: 1.63;
    letter-spacing: 0.1px;
    color: #333333;
    padding: 20px 0 0px 0;
    margin: 0 0 0 20px;
    & > li {
      padding-bottom: 8px;
      position: relative;
    }
  }

  @media (max-width: 768px) {
    padding: 0 20px;
    flex-basis: 100%;
    & > p:nth-child(1) {
      font-size: 12px;
      font-weight: 500;
      line-height: 1.33;
      letter-spacing: 0.1px;
    }
    & > p:nth-child(2) {
      font-size: 24px;
      font-weight: normal;
      line-height: 1.5;
      letter-spacing: 1.2px;
      text-transform: uppercase;
    }
    & > ol {
      font-size: 14px;
      font-weight: normal;
      line-height: 1.57;
      letter-spacing: 0.1px;
      margin: 10px 0;
    }
  }
  @media (max-width: 840px) {
    padding: 40px 0 0 20px;
  }
`

const CoreTeamWrapper = styled.div`
  padding: 80px 0 80px 0;
  max-width: 1366px;
  margin: 0 auto;
  & + section {
    & > p {
      max-width: 1366px;
      word-break: break-all;
    }
    & > button {
      margin-top: 14px;
    }
  }
  @media (max-width: 768px) {
    padding: 30px 0;
    & > p {
      text-align: center;
    }
  }
`

const TeamMemberWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 80px;
  flex-wrap: wrap;
  max-width: 80%;
  margin: 0 auto;

  & > div {
    display: flex;
    width: 33.33%;
    flex-direction: column;
    & > div:first-child {
      height: 300px;
      display: flex;
      align-items: center;
      justify-content: center;
      & > img {
        max-width: 190px;
      }
    }
    & > p:nth-child(2) {
      align-self: center;
      font-size: 20px;

      line-height: 1.52;
      text-align: center;
      color: #333333;
      margin: 0;
    }
    & > p:nth-child(3) {
      align-self: center;
      font-size: 16px;

      line-height: 1.63;
      letter-spacing: 0.1px;
      text-align: center;
      color: #999999;
      margin: 0;
    }
  }
  @media (max-width: 768px) {
    padding-top: 40px;
    max-width: 100%;
    padding-left: 20px;
    padding-right: 20px;
    & > div {
      width: 33.33%;
      & > img {
        object-fit: cover;
      }
    }
  }
  @media (max-width: 640px) {
    padding-top: 40px;
    max-width: 100%;
    padding-left: 20px;
    padding-right: 20px;
    & > div {
      width: 100%;
      & > img {
        object-fit: cover;
      }
    }
  }
`

/* const BottomPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 250px;
  & > h1 {
    font-size: 38px;

    line-height: 1.21;
    text-align: center;
    color: #333333;
  }
  & > p {
    font-size: 16px;

    line-height: 1.63;
    letter-spacing: 0.1px;
    text-align: center;
  }
  & > button {
    width: 170px;
    align-self: center;
    height: 48px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    background: white;
    border-radius: 3px;
    font-size: 14px;
    

    line-height: 1;
    letter-spacing: 1px;
    text-align: center;
    color: #333333;
    margin-top: 20px;
    cursor: pointer;
  }
`
 */
const FirstSet = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 370px;
  margin: 0 auto;
  position: relative;
  top: -10px;
  @media (max-width: 520px) {
    max-width: 240px;
  }
`
const SecondSet = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 620px;
  min-width: 620px;
  left: -50px;
  margin: 0 auto;
  padding: 100px 0;
  position: relative;
  @media (max-width: 520px) {
    max-width: 240px;
    min-width: 360px;
    padding: 50px 0;
    left: -20px;
  }
`
const ThirdSet = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 370px;
  margin: 0 auto;
  position: relative;
  bottom: -10px;
  @media (max-width: 520px) {
    max-width: 240px;
    min-width: 240px;
    bottom: -30px;
  }
`
const Placeholder = styled.div`
  font-size: 36px;
  width: 102px;
  height: 102px;
  border-radius: 50%;
  color: ${props => (props.selected ? '#fff' : '#999')};
  background-color: ${props => (props.selected ? '#f0425f' : '#ffffff')};
  box-shadow: ${props =>
    props.selected ? ' 0 8px 16px 0 rgba(240, 66, 95, 0.2)' : ' 0 8px 16px 0 rgba(0, 0, 0, 0.08);'};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  @media (max-width: 520px) {
    height: 60px;
    width: 60px;
    font-size: 28px;
  }
`
const ButtonHolder = styled.div`
  margin-top: 40px;
`

const HrEmail = styled.div`
  padding: 0 0 20px 0;
`

const perksArray = [
  'We give our employees the freedom to choose their work profile and enhance their skill set.',
  'We give our employees ownership and control of their work.',
  'Flexible working hours has been every employees’ desire and we believe in making our employees happy.',
  'We provide our employees half yearly appraisals to keep them updated about their performance and motivate them to work harder.',
  'We believe that employee growth leads to the growth of the organization, therefore we provide our employees all the necessary training.'
]
const content = {
  V: { title: 'Value', dec: 'Always looking for ways to add value to our clients, colleagues and industry.' },
  EEE: { title: 'Efficiency', dec: 'Embracing the latest technology and systems to save more time and money.' },
  C: {
    title: 'Customer Focus',
    dec: 'Customer Satisfaction is a strong contributor to our overall success of the business.'
  },
  T: {
    title: 'Transparency',
    dec: 'Operating with honesty, integrity and transparency. Being direct and upfront in all communication.'
  },
  E: {
    title: 'Enjoyment',
    dec: 'Enjoyment at workplace keeps everyone motivated and brings the best out of everyone.'
  },
  R: { title: 'Respect', dec: 'For our clients, work colleagues, other bookkeepers and the society.' }
}

export class Eula extends Component {
  state = {
    selected: 'V'
  }
  componentDidMount() {}
  render() {
    const { selected } = this.state

    return (
      <Fragment>
        <Header />
        <TopDiv>
          <IframeBox>
            <iframe
              title="frame"
              src="https://docs.google.com/document/d/e/2PACX-1vTQRb9xq6mjss84OW07IjNnvVxaZsaPTLZ-KUw-bVgodAXsAwN0Z7aQP8Y2Oc8s5dv5uXXu5wvOqC1T/pub"
            />
          </IframeBox>
        </TopDiv>

        <BodyWrapper>
          <Footer />
          <MobileFooter />
        </BodyWrapper>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Eula.js